import { z } from 'zod';
import { LandscapeResponseV3Dto } from '../dto/response/landscape-response-v3.dto';
import { LocalesLanguagesConstants } from '../../../../locales/locales';

export const addEditLandscapeSchema = z.object({
  name: z
    .string()
    .min(3, { message: 'Please provide a valid name' })
    .max(100, { message: 'Maximum length is 100' }),
  landscapeType: z
    .string()
    .min(1, { message: 'Please provide a valid landscape type' })
    .max(50, { message: 'Maximum length is 50' }),
  jurisdictionName: z
    .string()
    .max(100, { message: 'Maximum length is 100' })
    .optional(),
  countryCode: z
    .string({ message: 'Please select a valid country' })
    .min(1, { message: 'Please select a valid country' }),
  latitude: z.coerce
    .number<number>({ error: 'Please provide a valid latitude' })
    .min(-90, { message: 'Please provide a valid latitude' })
    .max(90, { message: 'Maximum value is 90' })
    .refine(
      (n) => {
        const value = n.toString();
        const hasPrecision = value.includes('.');
        if (!hasPrecision) return true;
        return value.split('.')[1]?.length <= 6;
      },
      {
        message: 'Maximum precision is 6 decimal places',
      }
    ),
  longitude: z.coerce
    .number<number>({ error: 'Please provide a valid longitude' })
    .min(-180, { message: 'Please provide a valid longitude' })
    .max(180, { message: 'Maximum value is 180' })
    .refine(
      (n) => {
        const value = n.toString();
        const hasPrecision = value.includes('.');
        if (!hasPrecision) return true;
        return value.split('.')[1]?.length <= 6;
      },
      {
        message: 'Maximum precision is 6 decimal places',
      }
    ),
  contactPersonName: z
    .string()
    .min(1, { message: 'Please provide a valid contact person name' }),
  contactPersonRole: z
    .string()
    .min(1, { message: 'Please provide a valid contact person role' }),
  contactPersonEmail: z
    .email({ error: 'Please provide a valid contact person e-mail' })
    .min(1, { message: 'Please provide a valid contact person e-mail' }),
  isPublished: z.boolean({
    error: 'Please select if Landscape is an initiative',
  }),
  isLandscapeInitiative: z.boolean(),
  language: z.string().min(1),
});

export type AddEditLandscapeForm = z.infer<typeof addEditLandscapeSchema>;

export const buildDefaultValues = (
  isEdit: boolean,
  data?: LandscapeResponseV3Dto
) => {
  if (!isEdit) {
    return {
      name: '',
      landscapeType: '',
      jurisdictionName: '',
      countryCode: '',
      latitude: undefined,
      longitude: undefined,
      contactPersonName: '',
      contactPersonRole: '',
      contactPersonEmail: '',
      isPublished: false,
      isLandscapeInitiative: false,
      language: LocalesLanguagesConstants.en,
    };
  }
  return {
    name: data?.name,
    landscapeType: data?.landscapeType,
    jurisdictionName: data?.jurisdictionName,
    countryCode: data?.countryCode,
    latitude: data?.latitude,
    longitude: data?.longitude,
    contactPersonName: data?.contactPerson[0].name,
    contactPersonRole: data?.contactPerson[0].role,
    contactPersonEmail: data?.contactPerson[0].email,
    isPublished: data?.isPublished,
    isLandscapeInitiative: data?.isLandscapeInitiative,
    language: data?.language,
  };
};
